<template>
  <b-modal
    modal-class="component-modal-txitem"
    id="TxItemModal"
    ref="TxItemModal"
    size="xl"
    title="รายการรักษา"
    hide-footer
    no-close-on-backdrop
    @close="close"
    @hide="close"
    @hidden="setDefaultValue"
  >
    <b-form @submit.prevent="saveTxItem">
      <div :class="{ 'disabled-treatment-form': !$canManageMasterData() }">
        <b-form-group label-cols="3" label="รหัส:" label-align="right">
          <b-form-input v-model="tx.code" class> </b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="3"
          label="ชื่อรายการ(ไทย):"
          label-align="right"
        >
          <b-form-input
            v-model="tx.nameTh"
            class="required"
            :class="{ 'is-invalid': $v.tx.nameTh.$error }"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="3"
          label="ชื่อรายการ(Eng):"
          label-align="right"
        >
          <b-form-input v-model="tx.nameEn"></b-form-input>
        </b-form-group>

        <b-form-row>
          <div class="col-3 text-right align-self-center">ประเภท:</div>
          <b-form-select
            v-model="tx.cateId"
            class="col mx-1 required"
            :options="getTreatCateList"
            value-field="id"
            text-field="nameTh"
            :class="{ 'is-invalid': $v.tx.cateId.$error }"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled
                >-- เลือกประเภท --</b-form-select-option
              >
            </template>
          </b-form-select>
          <b-button
            class="col-1 mx-1"
            block
            variant="secondary"
            @click="openTxCateItem()"
          >
            <i class="fas fa-edit"></i>
          </b-button>
        </b-form-row>
        <hr />
        <b-form-group label-cols="3" label="ราคา:" label-align="right">
          <b-input-group>
            <b-form-input
              number
              v-model.number="tx.price"
              class="required"
              :class="{ 'is-invalid': $v.tx.price.$error }"
            >
            </b-form-input>
            <template v-slot:append>
              <b-input-group-text>บาท</b-input-group-text>
            </template>
          </b-input-group>
        </b-form-group>

        <b-form-group
          label-cols="3"
          label="DF รายการรักษา:"
          label-align="right"
        >
          <b-row>
            <b-col cols="12" lg="4">
              <b-input-group>
                <b-form-input
                  v-model.number="tx.df"
                  number
                  class="required"
                  @keyup="validateDf(tx.df)"
                  :class="{ 'is-invalid': $v.tx.df.$error }"
                ></b-form-input>
                <template v-slot:append>
                  <b-input-group-text>{{
                    tx.dfType === 0 ? "%" : "บาท"
                  }}</b-input-group-text>
                </template>
              </b-input-group>
              <b-form-invalid-feedback
                v-if="$v.tx.df.$error && !$v.tx.df.validDf && tx.dfType === 0"
              >
                ค่าเปอร์เซ็นต์ต้องอยู่ระหว่าง 0 ถึง 100
              </b-form-invalid-feedback>
            </b-col>
            <b-col class="align-self-center">
              <b-form-radio-group v-model="tx.dfType" @change="onDfTypeChange">
                <b-form-radio :value="0">Percent</b-form-radio>
                <b-form-radio :value="1">Fixed</b-form-radio>
              </b-form-radio-group>
            </b-col>

            <b-col class="align-self-center" cols="5" lg="3">
              <b-button block v-b-toggle.dfDetail variant="secondary" size=""
                >DF เฉพาะท่าน</b-button
              >
            </b-col>
          </b-row>
        </b-form-group>
        <b-row>
          <b-col class="px-2" offset-lg="3">
            <b-collapse id="dfDetail" class="mr-2">
              <b-card>
                <div class="mb-3">
                  กรุณาเลือกแพทย์ที่ต้องการให้ DF เฉพาะท่าน
                  <br />ในกรณีที่ไม่ได้เลือก DF จะคิดเท่ากับ "DF รายการรักษา"
                </div>
                <div
                  class="mb-2"
                  v-for="(dfSpec, key, index) in tx.dfDoctors"
                  :key="dfSpec.uid"
                >
                  <b-row v-if="getDoctorListBy(dfSpec.doctorUid, 'uid')">
                    <b-col cols="6" class="pr-0">
                      <div class="text-right pt-1">
                        {{ getDoctorListBy(dfSpec.doctorUid, "uid").fullName }}
                        :
                      </div>
                    </b-col>
                    <b-col>
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <!-- เพิ่ม data dfActive อีกตัว?? -->
                          <b-form-checkbox
                            switch
                            v-model="dfSpec.dfActive"
                            @input="activateDfSpec(dfSpec)"
                          ></b-form-checkbox>
                        </b-input-group-prepend>
                        <b-form-input
                          number
                          v-model="dfSpec.df"
                          @keyup="validateDfItem(dfSpec, index)"
                          :disabled="!dfSpec.dfActive"
                          :class="{
                            'is-invalid':
                              dfSpec.dfActive &&
                              tx.dfType === 0 &&
                              (dfSpec.df < 0 || dfSpec.df > 100),
                          }"
                          required
                        ></b-form-input>
                        <b-input-group-append>
                          <b-input-group-text>{{
                            tx.dfType === 0 ? "%" : "บาท"
                          }}</b-input-group-text>
                        </b-input-group-append>
                      </b-input-group>
                      <div
                        class="invalid-feedback"
                        v-if="
                          dfSpec.dfActive &&
                          tx.dfType === 0 &&
                          (dfSpec.df < 0 || dfSpec.df > 100)
                        "
                      >
                        ค่าเปอร์เซ็นต์ต้องอยู่ระหว่าง 0 ถึง 100
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <!-- <b-form-group
                class="mb-1"
                v-for="(doctor,key,index) in tx.dfDoctor"
                :key="index"
                label-cols="6"
                :label="getDoctorListBy(doctor.doctorUid,'value').label + ' : '"
                label-align="right"
              >
                <b-row>
                  <b-input-group class="col">
                    <b-form-input
                      type="number"
                      v-model="doctor.df"
                      @keyup="validateDfItem(doctor.df,index)"
                    ></b-form-input>
                    <template v-slot:append></template>
                  </b-input-group>
                </b-row>
              </b-form-group>-->
              </b-card>
            </b-collapse>
          </b-col>
        </b-row>
      </div>
      <hr />

      <div class="display-column">
        <div class="d-flex flex-column">
          <div class="label-title">ผูกเข้ากับคลัง</div>
          <div class="label-description">
            ผูกการรักษากับสินค้าจากคลัง
            เพื่อกำหนดรายการสินค้าที่ต้องถูกตัดสต๊อกเมื่อมีการใช้งาน
          </div>
        </div>
        <template v-if="treatmentStockBinding.length > 0">
          <b-table
            id="TreatmentStockBindingTable"
            ref="TreatmentStockBindingTable"
            hover
            small
            sort-icon-left
            head-variant="light"
            :items="treatmentStockBinding"
            :fields="fields"
          >
            <template v-slot:cell(index)="row">
              <div class="d-flex align-items-center justify-content-center">
                {{ row.index + 1 }}.
              </div>
            </template>

            <template v-slot:cell(image)="row">
              <ProductImage
                :disabled="!row.item.productNoAndName"
                :src="
                  productList.find(
                    p => p.productId === row.item.productNoAndName?.id
                  )?.imageUrl || null
                "
              />
            </template>

            <template v-slot:cell(productNoAndName)="row">
              <div class="product-no-and-name-wrapper">
                <multiselect
                  class="col p-0 required"
                  v-model="row.item.productNoAndName"
                  :options="getProductOptions(row.index)"
                  :multiple="false"
                  placeholder="เลือกสินค้า"
                  @input="onProductNoAndNameChange(row)"
                  track-by="id"
                  :custom-label="item => item.name || ''"
                  selectLabel="เลือกสินค้า"
                  selectedLabel="เลือกแล้ว"
                  deselectLabel="คลิกเพื่อลบออก"
                  openDirection="below"
                  :class="{
                    'is-invalid':
                      $v.treatmentStockBinding.$each[row.index] &&
                      $v.treatmentStockBinding.$each[row.index].productNoAndName
                        .$error,
                  }"
                  :disabled="!$canManageMasterData()"
                >
                  <span slot="noResult">ไม่พบรายการ แนะนำเปลี่ยนคำค้นหา</span>
                </multiselect>
                <template
                  v-if="
                    $v.treatmentStockBinding.$each[row.index] &&
                    $v.treatmentStockBinding.$each[row.index].productNoAndName
                      .$error
                  "
                >
                  <div class="invalid-icon-position">
                    <i class="icon-invalid-exclamation"></i>
                  </div>
                </template>
              </div>
            </template>

            <template v-slot:cell(productAmount)="row">
              <b-form-input
                v-model="row.item.productAmount"
                class="required"
                placeholder="กรอกจำนวน"
                inputmode="numeric"
                maxlength="10"
                :disabled="!row.item.productNoAndName || !$canManageMasterData()"
                @keydown="allowOnlyNumber($event)"
                @blur="onBlurProductAmount(row.item)"
                :class="{
                  'is-invalid':
                    $v.treatmentStockBinding.$each[row.index] &&
                    $v.treatmentStockBinding.$each[row.index].productAmount
                      .$error,
                }"
              ></b-form-input>
            </template>

            <template v-slot:cell(productUnit)="row">
              <span :class="{ 'text-muted': !row.item.productNoAndName }">
                {{ row.item.productNoAndName ? row.item.productUnit : "???" }}
              </span>
            </template>

            <template v-slot:cell(buttons)="row">
              <button
                type="button"
                class="delete-btn"
                @click="deleteTreatmentStockBinding(row.index)"
                :disabled="!$canManageMasterData()"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </template>
          </b-table>
        </template>
        <b-button
          type="button"
          variant="outline-primary"
          class="button-width"
          @click="addTreatmentStockBinding"
          :disabled="!$canManageMasterData()"
        >
          <i class="fas fa-plus"></i> เพิ่มรายการสินค้า
        </b-button>
      </div>

      <div :class="{ 'hidden-btn-treatment-form': !$canManageMasterData() }">
        <hr />
        <b-row class="d-flex flex-row-reverse">
          <div>
            <b-button class="ml-2 mr-3" type="submit" variant="primary">{{
              tx.id ? "แก้ไขรายการ" : "สร้างรายการ"
            }}</b-button>
          </div>
          <div>
            <b-button
              variant="danger"
              v-if="tx.id && $canManageMasterData()"
              @click="deleteTxItem(tx)"
              >ลบรายการ</b-button
            >
          </div>
        </b-row>
      </div>
    </b-form>
    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
    <CateManage
      ref="TxCateItem"
      title="ประเภทการรักษา"
      :categoryList="getTreatCateList"
      :createCategoryFn="createTreatmentCate"
      :deleteCategoryFn="deleteTreatmentCate"
      :updateCategoryFn="updateTreatmentCate"
      :fetchCategoryFn="fetchTreatCateList"
    />
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import CateManage from "@/components/modal/CateManage";
import ProductImage from "@/components/table/stock/component/ProductImage.vue";
import { mapActions, mapGetters } from "vuex";
import {
  required,
  requiredIf,
  numeric,
  minLength,
  between,
  sameAs,
  not,
  helpers,
  email,
} from "vuelidate/lib/validators";
import "@/theme/modal/AptItem.scss";
import { Status } from "@/constants/productStock";

export default {
  name: "TxItemModal",
  components: {
    Dialog,
    Loading,
    CateManage,
    ProductImage,
  },
  data() {
    return {
      isLoading: false,
      Status,
      productList: [],
      tx: {
        id: null,
        code: "",
        nameTh: "",
        nameEn: "",
        cateId: null,
        favorite: false,
        price: 0,
        df: 50,
        dfType: 0,
        dfDoctors: [],
      },
      treatmentStockBinding: [],
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "5%" },
          tdStyle: { width: "5%" },
        },
        {
          key: "image",
          label: "",
          thStyle: { width: "6%" },
          tdStyle: { width: "6%" },
        },
        {
          key: "productNoAndName",
          label: "สินค้า",
          thStyle: { width: "40%" },
          tdStyle: { width: "40%" },
        },
        {
          key: "productAmount",
          label: "จำนวนสินค้า",
          thStyle: { width: "22%" },
          tdStyle: { width: "22%" },
        },
        {
          key: "productUnit",
          label: "หน่วยสินค้า",
          thStyle: { width: "20%" },
          tdStyle: { width: "20%" },
          tdClass: "text-wrap-cell",
        },
        {
          key: "buttons",
          label: "",
          thStyle: { width: "7%" },
          tdStyle: { width: "7%" },
        },
      ],
    };
  },
  validations: {
    tx: {
      nameTh: { required },
      price: { required },
      cateId: { required },
      df: {
        required,
        validDf: function (value) {
          if (this.tx.dfType === 0) {
            return value >= 0 && value <= 100;
          }
          return true;
        },
      },
    },
    treatmentStockBinding: {
      $each: {
        productNoAndName: {
          required(value) {
            return !!(value && value.id);
          },
        },
        productAmount: {
          required(value, row) {
            if (!row || !row.productNoAndName || !row.productNoAndName.id)
              return true;
            return value != null && Number(value) !== 0;
          },
        },
      },
    },
  },
  computed: {
    ...mapGetters({
      getTreatCateList: "moduleAppointment/getTreatCateList",
      getDoctorList: "moduleUser/getDoctorList",
      getDoctorListBy: "moduleUser/getDoctorListBy",
      branchInfo: "moduleUser/getBranchInfo",
    }),
    productOptions() {
      return this.productList
        .filter(
          product =>
            product.productStatus === Status.LOCKED ||
            product.productStatus === Status.ACTIVE
        )
        .map(product => ({
          id: product.productId,
          name: `${product.productCode} - ${product.productNameMain}`,
        }));
    },
  },
  watch: {},
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      createTreatmentCate: "moduleAppointment/createTreatmentCate",
      updateTreatmentCate: "moduleAppointment/updateTreatmentCate",
      deleteTreatmentCate: "moduleAppointment/deleteTreatmentCate",
      fetchTreatCateList: "moduleAppointment/fetchTreatCateList",
    }),
    init() {},
    show(data) {
      const { txItem, productList } = data;
      this.productList = productList;

      if (txItem) {
        this.isLoading = true;
        this.$store
          .dispatch("moduleAppointment/findTreatListById", {
            event: txItem,
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          })
          .then(res => {
            if (res.status == 200) {
              this.tx = Object.assign({}, res.data);

              if (res.data.products && res.data.products.length > 0) {
                this.treatmentStockBinding = res.data.products.map(p => ({
                  productNoAndName: {
                    id: p.productId,
                    name:
                      `${p.product?.no || ""} - ${
                        p.product?.description || ""
                      }`.trim() || "Unknown",
                  },
                  productAmount: p.qty,
                  productUnit: p.product?.baseUom?.description || "???",
                }));
              } else {
                this.treatmentStockBinding = [];
              }

              this.$bvModal.show("TxItemModal");
            }
          })
          .finally(() => {
            this.isLoading = false;
            this.setDfDoctor();
          });
      } else {
        this.tx.df = this.branchInfo.df;
        this.setDfDoctor();
        this.$bvModal.show("TxItemModal");
      }
    },
    async saveTxItem() {
      // Defense-in-depth: the form body is only visually disabled via
      // pointer-events, and the hidden submit button doesn't stop Enter-key
      // submission. Re-check permission before mutating.
      if (!this.$canManageMasterData()) {
        this.$refs.Dialog.showToast(
          "danger",
          "คุณไม่มีสิทธิ์แก้ไขข้อมูลรายการรักษา"
        );
        return;
      }

      this.$v.$touch();

      if (this.treatmentStockBinding.length === 0) {
        this.$v.treatmentStockBinding.$reset();
      }

      if (this.$v.$invalid) {
        return;
      }

      const products = this.treatmentStockBinding.map(item => {
        return {
          productId: item.productNoAndName.id,
          qty: Number(item.productAmount),
        };
      });

      // Additional validation for percentage values before saving
      if (this.tx.dfType === 0 && (this.tx.df < 0 || this.tx.df > 100)) {
        this.$parent.showDialogToast(
          "warning",
          "ค่าเปอร์เซ็นต์ต้องอยู่ระหว่าง 0 ถึง 100"
        );
        return;
      }

      // Validate doctor-specific DF values if they are percentages
      const invalidDfDoctors = this.tx.dfDoctors.filter(
        dfSpec =>
          dfSpec.dfActive &&
          this.tx.dfType === 0 &&
          (dfSpec.df < 0 || dfSpec.df > 100)
      );

      if (invalidDfDoctors.length > 0) {
        this.$parent.showDialogToast(
          "warning",
          "ค่าเปอร์เซ็นต์ DF เฉพาะท่านต้องอยู่ระหว่าง 0 ถึง 100"
        );
        return;
      }

      // Confirm when df exceeds price in fixed amount mode
      if (this.tx.dfType === 1 && this.tx.df > this.tx.price) {
        const { isConfirmed } = await this.$parent.$refs.Dialog.showAlertConfirm(
          "DF มากกว่าราคา",
          `DF (${this.tx.df} บาท) มากกว่าราคา (${this.tx.price} บาท) ต้องการบันทึกหรือไม่?`,
          "warning",
          "ยืนยัน",
          "ยกเลิก"
        );
        if (!isConfirmed) return;
      }

      this.isLoading = true;
      delete this.tx.creationDt;
      delete this.tx.modifyDt;
      this.tx.dfDoctors = this.tx.dfDoctors.filter(i => i.dfActive);
      if (!this.tx.id) {
        delete this.tx.id;
        this.$store
          .dispatch("moduleAppointment/createTreatList", {
            event: {
              ...this.tx,
              products,
            },
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          })
          .then(res => {
            if (res.status == 200) {
              this.$parent.showDialogToast(
                "success",
                `สร้างรายการ "${this.tx.nameTh}" สำเร็จ`
              );
            }
          })
          .finally(() => {
            this.isLoading = false;
            this.$bvModal.hide("TxItemModal");
            this.setDefaultValue();
          });
      } else {
        this.$store
          .dispatch("moduleAppointment/updateTreatList", {
            event: {
              ...this.tx,
              products,
            },
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          })
          .then(res => {
            this.$parent.showDialogToast(
              "success",
              `แก้ไขรายการ "${this.tx.nameTh}" สำเร็จ`
            );
          })
          .finally(() => {
            this.isLoading = false;
            this.$bvModal.hide("TxItemModal");
            this.setDefaultValue();
          });
      }
    },
    deleteTxItem(eventData) {
      // Defense-in-depth: matches the guard in saveTxItem above.
      if (!this.$canManageMasterData()) {
        this.$refs.Dialog.showToast(
          "danger",
          "คุณไม่มีสิทธิ์ลบข้อมูลรายการรักษา"
        );
        return;
      }

      this.$refs.Dialog.showAlertConfirm(
        "ลบการรักษานี้ ?",
        "คุณต้องการลบการรักษานี้"
      ).then(result => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("moduleAppointment/deleteTreatList", {
              event: eventData,
              clinicUrl: this.$route.params.clinicUrl,
              branchUrl: this.$route.params.branchUrl,
            })
            .then(res => {
              if (res.status == "200") {
                this.setDefaultValue();
                this.$parent.showDialogToast(
                  "success",
                  `ลบรายการ "${eventData.nameTh}" สำเร็จ`
                );
              }
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
              this.$parent.showDialogToast(
                "warning",
                `ลบรายการ "${eventData.nameTh}" ไม่สำเร็จ`
              );
            })
            .finally(() => {
              this.$bvModal.hide("TxItemModal");
            });
        }
      });
    },
    close() {
      this.$v.$reset();
      this.setDefaultValue();
    },
    setDefaultValue() {
      this.tx = Object.assign(
        {},
        {
          id: null,
          code: "",
          nameTh: "",
          nameEn: "",
          cateId: null,
          favorite: false,
          price: 0,
          df: 50,
          dfType: 0,
          dfDoctors: [],
        }
      );
      this.treatmentStockBinding = [];
    },
    setDfDoctor() {
      let doctorList = this.getDoctorList.map(doctor => {
        let dfActive = false;
        let df = null;
        let index = this.tx.dfDoctors?.findIndex(ds => {
          return ds.doctorUid === doctor.uid;
        });
        if (index >= 0) {
          df = this.tx.dfDoctors[index].df;
          dfActive = true;
        }
        return {
          doctorUid: doctor.uid,
          df,
          dfActive,
        };
      });
      this.tx.dfDoctors = [...doctorList];
    },
    openTxCateItem() {
      this.$refs.TxCateItem.show();
    },
    validateDf(df) {
      if (this.tx.dfType == 0) {
        if (df > 100) {
          this.tx.df = 100;
        }
      }
    },
    validateDfItem(dfSpec, index) {
      // For dfSpec.df, we only validate but don't change values
      // Force UI update to show validation state
      this.$forceUpdate();
    },
    activateDfSpec(dfSpec) {
      if (!dfSpec.dfActive) {
        dfSpec.df = null;
      }
    },
    onDfTypeChange() {
      // Validate the main form when type changes
      this.$v.$touch();

      // Force re-evaluation of all doctor-specific DF values to update their validation state
      this.tx.dfDoctors.forEach((dfSpec, index) => {
        if (dfSpec.dfActive) {
          // Just trigger validation by accessing the property
          this.$forceUpdate();
        }
      });
    },
    getProductOptions(currentIndex) {
      const selectedInOtherRows = new Set(
        this.treatmentStockBinding
          .map((item, i) =>
            i !== currentIndex && item.productNoAndName?.id
              ? item.productNoAndName.id
              : null
          )
          .filter(Boolean)
      );
      return this.productOptions.filter(
        product => !selectedInOtherRows.has(product.id)
      );
    },
    createEmptyTreatmentStockBinding() {
      return {
        productNoAndName: "",
        productAmount: null,
        productUnit: "???",
      };
    },
    addTreatmentStockBinding() {
      const wasEmpty = this.treatmentStockBinding.length === 0;

      this.treatmentStockBinding.push(this.createEmptyTreatmentStockBinding());

      if (wasEmpty) {
        this.$nextTick(() => {
          this.$v.treatmentStockBinding.$reset();
        });
      }
    },
    deleteTreatmentStockBinding(index) {
      this.treatmentStockBinding.splice(index, 1);
    },
    allowOnlyNumber(e) {
      const allowedKeys = [
        "Backspace",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "Delete",
      ];
      if (allowedKeys.includes(e.key)) return;

      if (/^\d$/.test(e.key)) return;

      e.preventDefault();
    },
    onBlurProductAmount(item) {
      const raw = String(item?.productAmount ?? "").trim();
      if (raw === "") return;
      const num = parseInt(raw, 10);
      item.productAmount = isNaN(num) ? "0" : String(num);
    },
    onProductNoAndNameChange(row) {
      row.item.productAmount = null;
      if (row.item.productNoAndName?.id) {
        const product = this.productList.find(
          p => p.productId === row.item.productNoAndName.id
        );
        row.item.productUnit = product.productUnit.description;
      }

      const rowValidation = this.$v.treatmentStockBinding.$each?.[row.index];
      if (rowValidation?.productAmount?.$reset) {
        rowValidation.productAmount.$reset();
      }
    },
  },
};
</script>

<style scoped>
.required {
  background-color: #ccecff6c;
}

.display-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.button-width {
  width: 161px;
}

.button-width:disabled {
  background-color: #fff !important;
  color: #ebebeb !important;
  border-color: #ebebeb !important;
  cursor: not-allowed;
}

.label-title {
  font-size: 18px;
  font-weight: 600;
}

.label-description {
  font-size: 16px;
  font-weight: 400;
  color: #6d747d;
}

::v-deep .multiselect__tags {
  background-color: #ccecff6c;
  box-shadow: none;
}

::v-deep .multiselect__single,
::v-deep .multiselect__input,
::v-deep .multiselect__placeholder {
  background-color: transparent !important;
}

::v-deep span.multiselect__placeholder {
  margin-left: 6px !important;
}

::v-deep .multiselect__input,
::v-deep .multiselect__single {
  padding-left: 6px;
}

::v-deep span.multiselect__single {
  margin-left: 6px !important;
}

::v-deep .multiselect__single {
  margin-bottom: 0;
  padding-left: 0;
}

::v-deep .multiselect__tags {
  box-shadow: none;
  position: relative;
}

::v-deep .multiselect--disabled {
  background-color: #ebebeb !important;
  color: #c6c6c6 !important;
  opacity: 1 !important;
  border: 1px solid #ced4da !important;
  border-radius: 4px;
  overflow: hidden;
}

::v-deep .multiselect--disabled .multiselect__tags {
  background-color: #ebebeb !important;
  cursor: not-allowed;
  overflow: hidden;
  color: #c6c6c6 !important;
  z-index: 1;
  position: relative;
  border: none !important;
}

::v-deep .multiselect--disabled .multiselect__placeholder {
  background-color: #ebebeb !important;
  color: #c6c6c6 !important;
}

::v-deep .multiselect--disabled .multiselect__select {
  background-color: #ebebeb !important;
  cursor: not-allowed;
  z-index: 0;
  overflow: hidden;
}

::v-deep #TreatmentStockBindingTable {
  margin-bottom: 0px !important;
}

::v-deep #TreatmentStockBindingTable tbody tr td {
  border-bottom: 1px solid #dee2e6 !important;
}

::v-deep #TreatmentStockBindingTable.table-hover tbody tr:hover {
  background-color: transparent !important;
}

::v-deep #TreatmentStockBindingTable thead tr th,
::v-deep #TreatmentStockBindingTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #TreatmentStockBindingTable .bottom-row-cell {
  text-align: left !important;
}

::v-deep .btn-delete-adjustment:disabled {
  border-color: #dee2e6 !important;
  color: #dee2e6 !important;
}

::v-deep .form-control:disabled {
  background-color: #ebebeb !important;
  color: #c6c6c6 !important;
}

::v-deep #TreatmentStockBindingTable td.text-wrap-cell {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

::v-deep .delete-btn {
  background-color: transparent;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  color: #a3a4a6;
  font-size: 20px;
  width: 48px;
  height: 38px;
}

.delete-btn:hover:not(:disabled) {
  background-color: #d33;
  color: #fff;
}

.delete-btn:disabled {
  border-color: #ebebeb !important;
  color: #ebebeb !important;
  cursor: not-allowed;
}

.product-no-and-name-wrapper {
  position: relative;
}

.invalid-icon-position {
  position: absolute;
  top: 47%;
  right: 32px;
  transform: translateY(-50%);
  color: #dc3545;
  width: 16px;
  height: 16px;
}

.icon-invalid-exclamation {
  background-image: url("~@/assets/icon/invalid-exclamation.svg");
  display: inline-block;
  width: 18px;
  height: 18px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.disabled-treatment-form {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.hidden-btn-treatment-form {
  display: none;
}
</style>
